import { render, staticRenderFns } from "./Keyword.vue?vue&type=template&id=19bb81ef"
import script from "./Keyword.vue?vue&type=script&lang=js"
export * from "./Keyword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports